import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import greatLearningImage from '../../../assets/images/Great Learning Image.png';

const certificates = [
  {
    title: 'What Is IoT',
    issuedBy: 'Great Learning',
    date: 'May 2024',
    image: greatLearningImage,
    link: 'https://drive.google.com/file/d/1cx99Bfan0OyHEhFLfm6TT3k7IvW_b1no/view?usp=drive_link'
  },
  {
    title: 'Introduction To Express JS',
    issuedBy: 'Great Learning',
    date: 'July 2024',
    image: greatLearningImage,
    link: 'https://drive.google.com/file/d/1ua9d9H-b_OMyYByXU2fzrRToEbW5lA8Y/view?usp=drive_link'
  },
  {
    title: 'React JS Tutorial',
    issuedBy: 'Great Learning',
    date: 'December 2024',
    image: greatLearningImage,
    link: 'https://drive.google.com/file/d/1aBEeTP9N5xVw7mTdEzq_nXqYegFInKBI/view?usp=drive_link'
  },
  {
    title: 'Android Studio Tutorial',
    issuedBy: 'Great Learning',
    date: 'December 2024',
    image: greatLearningImage,
    link: 'https://drive.google.com/file/d/1WZCu9osoF_LiIrInBbIEYaRVYStCK603/view?usp=drive_link'
  },
  {
    title: 'Google Gemini For Coders',
    issuedBy: 'Great Learning',
    date: 'December 2024',
    image: greatLearningImage,
    link: 'https://drive.google.com/file/d/19zQqIsuhDY3l1TLaRQtPgZ9wJznBASbZ/view?usp=drive_link'
  },
  {
    title: 'Prompt Engineering',
    issuedBy: 'Great Learning',
    date: 'December 2024',
    image: greatLearningImage,
    link: 'https://drive.google.com/file/d/1o8Ub8Ch9eT72ZUQTuEbHSbox_nCZaFUB/view?usp=drive_link'
  },
  {
    title: 'HTML Tutorial',
    issuedBy: 'Great Learning',
    date: 'December 2024',
    image: greatLearningImage,
    link: 'https://drive.google.com/file/d/1lbmPXwcsBc6qcDAQ-JSb-DJS1sfBkTS7/view?usp=drive_link'
  },
  {
    title: 'UI/UX For Begineers',
    issuedBy: 'Great Learning',
    date: 'December 2024',
    image: greatLearningImage,
    link: 'https://drive.google.com/file/d/1yyc8gncqKRLjTWFGWEGdOnhiK3j5CIjN/view?usp=drive_link'
  }
];

const GreatLearningCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="Great Learning"
      certificates={certificates}
    />
  );
};

export default GreatLearningCertificates;
